__turbopack_context__.v({
  "body": "fXpXCq_body",
  "bodyDesktop": "fXpXCq_bodyDesktop",
  "bodyMobile": "fXpXCq_bodyMobile",
  "caption": "fXpXCq_caption",
  "card": "fXpXCq_card",
  "cardBody": "fXpXCq_cardBody",
  "cardTitle": "fXpXCq_cardTitle",
  "eyebrow": "fXpXCq_eyebrow",
  "grid": "fXpXCq_grid",
  "image": "fXpXCq_image",
  "inner": "fXpXCq_inner",
  "intro": "fXpXCq_intro",
  "media": "fXpXCq_media",
  "overlay": "fXpXCq_overlay",
  "overlayAsset": "fXpXCq_overlayAsset",
  "picture": "fXpXCq_picture",
  "scrim": "fXpXCq_scrim",
  "section": "fXpXCq_section",
  "title": "fXpXCq_title",
  "titleDesktop": "fXpXCq_titleDesktop",
  "titleMobile": "fXpXCq_titleMobile",
});
